import React, {FC, useCallback, useContext, useEffect, useState} from 'react';
import classNames from 'classnames';
import {useFormik} from 'formik';
import {useStoreon} from 'storeon/react';
import cnBind from 'classnames/bind';
import dayjs from 'dayjs';
import {GxButton, GxForm, GxRadio, GxSpinner} from '@garpix/garpix-web-components-react';
import { api } from '@/api';
import { State } from '@/interfaces';
import { IUserDepositList } from '@/types';
import Input from '../../../../../../components/Input';
import styles from './styles/index.module.scss';
import {ITEMS_BLOCK_PAY_HERE, PAYMENT_ITEMS, PAYMENT_TYPE, TYPES_SCORE, validationSchemaPaymentCash} from '../../../../consts';
import InputNumbers from '../../../../../../components/InputNumbers';
import Radio from '../../../../../../components/Radio';
import {createPayment, DEPOSITS_INFO} from '../../../../helpers';
import {ARR_TYPE, ORDERS, TITLE_DEPOSIT_NUll, TYPES_DEPOSITS} from '../../../../../../const';
import {Context} from '../../const';
import {IPayOrder} from '../../interfaces';
import {NAME_TYPES_CERTIFICATE, TYPES_CERTIFICATE} from '../../../../../Certificates/const';
import { SIDEBAR_TYPES } from '../../../ModalPayCertificateOrDeposit/const';

const PayOrder: FC<IPayOrder> = ({onBack, priceInfo}) => {
    const [activeItem, setActiveItem] = useState<PAYMENT_TYPE | null>(null);
    const {depositListUser, dispatch, certificatesUser} = useStoreon<State>('depositListUser','certificatesUser');
    const [flagSpinner, setFlagSpinner] = useState(false);
    const toggleFlagSpinner = useCallback(() => setFlagSpinner((prev) => !prev), []);
    const [{info}] = useContext<any>(Context);
    const {id, number, side, customer, tariff_rate, pay_order, price, price_paid} = info;

    const cn = cnBind.bind(styles);

    const formik = useFormik({
        enableReinitialize: true,
        validationSchema: activeItem !== PAYMENT_TYPE.DEPOSITS && validationSchemaPaymentCash,
        initialValues: {
            amount: 0,
            deposit_type: TYPES_DEPOSITS.MONEY,
            deposit_id: undefined,
            comment: '',
            certificate_id: undefined
        },
        validateOnChange: false,
        validateOnBlur: false,
        onSubmit(values) {
          toggleFlagSpinner();
          const depositType = values.deposit_type === 0 ? 2 : 3
          if (activeItem === null) {
            return
          }
          createPayment(
            {
              data: {
                amount: String(values.amount),
                deposit_id: activeItem === 11 ? values.deposit_id : undefined,
                order_id: id,
                comment: values.comment,
                certificate_id: activeItem === PAYMENT_TYPE.CERTIFICATE ? values.certificate_id : undefined,
                payment_method: activeItem === 11 ? depositType : activeItem,
                is_mass_booking: false
              },
              name: number,
              typePayment: ITEMS_BLOCK_PAY_HERE[activeItem].title
            }
            ).then(() => {
                onBack();
                // updateOrder();
                dispatch('orders/get');
                toggleFlagSpinner();
            }).catch(()=>toggleFlagSpinner())
        }
    })

    const isResourcePayment =
      activeItem === PAYMENT_TYPE.CERTIFICATE ||
      (activeItem === PAYMENT_TYPE.DEPOSITS && formik.values.deposit_type !== TYPES_DEPOSITS.MONEY);
    const resourceUnit = side === ORDERS.PIPE ? 'мин.' : 'сет(ов)';
    const orderResourceTotal = side === ORDERS.PIPE ? tariff_rate.minutes : tariff_rate.count_people;

    const list = depositListUser[ARR_TYPE[side] as keyof IUserDepositList];
    const isNotMoneyDeposit = typeof list !== 'number'

    useEffect(() => {
        if (info) {
            api.user.getUserTypes().then(({ results }) => {
                if (info.user_type_slug !== '') {
                    results.filter((el) => {
                        if (el.slug === info.user_type_slug) {
                            dispatch('depositListUser/get', { user_id: customer.id, is_has_resource: true, order: id, user_type: `0,${el.id}` });
                        }
                        return false;
                    })
                } else {
                    switch (info.side) {
                        case SIDEBAR_TYPES.PIPE:
                            results.filter((el) => {
                                if (el.slug === customer.tube_user_type) {
                                    dispatch('depositListUser/get', { user_id: customer.id, is_has_resource: true, order: id, user_type: `0,${el.id}` });
                                }
                                return false;
                            });
                            break;
                        case SIDEBAR_TYPES.WAVE:
                            results.filter((el) => {
                                if (el.slug === customer.wave_user_type) {
                                    dispatch('depositListUser/get', { user_id: customer.id, is_has_resource: true, order: id, is_expired: false, user_type: `0,${el.id}` });
                                }
                                return false;
                            })
                            break;
                        default:
                            results.filter((el) => {
                                if (el.slug === customer.tube_user_type) {
                                    dispatch('depositListUser/get', { user_id: info.customer.id, is_has_resource: true, order: id, is_expired: false, user_type: `0,${el.id}` });
                                }
                                return false;
                            });
                    }
                }
            })
        }

        dispatch('certificatesUser/get', { customer_id: customer.id, orders: id, is_has_resource: true, status:3, side: [0, side] })
    }, [info])

    useEffect(()=>{
        const amount = ((activeItem === PAYMENT_TYPE.DEPOSITS && formik.values.deposit_type === TYPES_DEPOSITS.PIPE) || activeItem === PAYMENT_TYPE.CERTIFICATE ) ?
            (side === 1 ? tariff_rate.minutes : tariff_rate.count_people)
            : formik.values.deposit_type === TYPES_DEPOSITS.MONEY ? price - price_paid : 0
        formik.setFieldValue('amount',amount)
    },[activeItem,formik.values.deposit_type])

    useEffect(() => {
        if (activeItem !== PAYMENT_TYPE.CERTIFICATE && formik.values.certificate_id ){
          formik.setFieldValue('certificate_id', undefined)
        }

        if(certificatesUser.results.length > 0 && activeItem === PAYMENT_TYPE.CERTIFICATE){
            formik.setFieldValue('deposit_id', undefined)
        }

        const orders = isNotMoneyDeposit ? list.filter((item)=> item.expiry_at === null ? true : dayjs(item.expiry_at).isSameOrAfter(dayjs())) : [];
        if( orders.length > 0 && (formik.values.deposit_type === TYPES_DEPOSITS.PIPE || formik.values.deposit_type === TYPES_DEPOSITS.WAVE)){
            formik.setFieldValue('deposit_id', orders[0].id)
        }
    }, [activeItem, formik.values.deposit_type]);

    const getValueDepositField = (item:  Record<string, any>) =>{
      if (formik.values.deposit_type === TYPES_DEPOSITS.WAVE){
        if (item.rent_pay_count){
          return `${item.rent_pay_count} ар.`
        }
          return `${item.sets} сет.`
      }
      if (item.minutes){
        return `${item.minutes} мин.`
      }
      return '0'
    }

    const isDepositPaymentDisabled = formik.values.deposit_type !== TYPES_DEPOSITS.MONEY && !formik.values.deposit_id
    const isCertificatePaymentDisabled = activeItem === PAYMENT_TYPE.CERTIFICATE && !formik.values.certificate_id

    const isDisabledPayment = isDepositPaymentDisabled || activeItem === null || isCertificatePaymentDisabled

    const getCertificateResources = (certificate: Record<string, any>) => {
        const {
            side: certificateSide,
            remaining_minutes_fly,
            remaining_sets_wave,
            remaining_rent_pays
        } = certificate;

        const isHybrid = certificateSide !== ORDERS.PIPE && certificateSide !== ORDERS.WAVE;
        const isRent = certificateSide === ORDERS.WAVE && remaining_rent_pays > 0;

        let pipeMinutes: string | number = '-';
        let waveResource: string | number = '-';

        if (isHybrid) {
            if (remaining_minutes_fly) {
                pipeMinutes = `${remaining_minutes_fly} мин.`;
            }
            if (remaining_sets_wave) {
                waveResource = `${remaining_sets_wave} сет(ов)`;
            }
        } else if (isRent) {
            waveResource = `${remaining_rent_pays} аренд(ы)`;
        } else if (certificateSide === ORDERS.PIPE) {
            pipeMinutes = remaining_minutes_fly ? `${remaining_minutes_fly} мин.` : '-';
        } else if (certificateSide === ORDERS.WAVE) {
            waveResource = remaining_sets_wave ? `${remaining_sets_wave} сет(ов)` : '-';
        }

        return { pipeMinutes, waveResource };
    };

    return (
      <>
        <GxForm onGx-submit={formik.submitForm}>
            <div className={styles['subheader']}>
                <span className={styles['subheader--subtitle']}>Способ оплаты:</span>
            </div>
            {pay_order.status !== TYPES_SCORE.PAY_SUCCESS &&
                <div className={styles['actions']}>
                    {PAYMENT_ITEMS.filter((item) => item.flag).map((item) => (
                        <Radio
                            key={item.id}
                            name="pay"
                            className={styles['actions--item']}
                            checked={activeItem === item.id}
                            onClick={() => {
                                setActiveItem(item.id)
                            }}>
                            {item.title}
                        </Radio>
                    ))}
                </div>
            }
            {pay_order.status !== TYPES_SCORE.PAY_SUCCESS &&

            <div className={styles['wrap-group']}>

                <div className={styles['group']}>
                  <InputNumbers
                    label='Сумма оплаты:'
                    name="amount"
                    value={formik.values.amount}
                    handleInput={(e: Record<string, any>) => {
                        formik.setFieldValue('amount', e.target.value)
                    }}
                    disabled={activeItem === PAYMENT_TYPE.DEPOSITS || activeItem === PAYMENT_TYPE.CERTIFICATE }
                    className={cn({
                        'group--input': true,
                        'group--input--error': formik.errors.amount
                    })}
                    type='number'
                  />
                    {isResourcePayment ? (
                        <span> {resourceUnit}</span>
                    ) : (
                        <span> ₽</span>
                    )}
                  <p className={styles['group--error']}>{formik.errors.amount}</p>
                </div>
                    <div className={styles['group']}>
                        <Input
                            label='Примечание:'
                            name="comment"
                            className={cn(styles['group--input'])}
                            value={formik.values.comment}
                            handleChange={(e: React.FormEvent<HTMLInputElement>) => { formik.setFieldValue('comment', e.currentTarget.value) }}
                        />
                    </div>
                </div>
            }
            {activeItem === PAYMENT_TYPE.DEPOSITS &&
            <div className={styles['deposit-pay']}>
              <div className={styles['certificate']}>
                <div className={styles['subheader']}>
                  <span className={styles['subheader--subtitle']}>Выбор депозита</span>
                </div>
                <div className={cn(styles['table'], styles['table--deposit'])}>
                  <table style={{display: 'table', maxWidth: '100%'}}>
                    <thead>
                    <tr>
                      <th>Название</th>
                      <th>Сумма</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                      <td>
                        <GxRadio
                          onGx-change={() => formik.setFieldValue('deposit_type', TYPES_DEPOSITS.MONEY)}
                          name="typeCertificate"
                          checked={formik.values.deposit_type === TYPES_DEPOSITS.MONEY}>Денежный</GxRadio>
                      </td>
                      <td>{Number(customer.deposit_money)}</td>
                    </tr>
                    {DEPOSITS_INFO(depositListUser)
                        .filter((el: Record<string, any>) => side === ORDERS.PIPE
                            ? el.id === TYPES_DEPOSITS.PIPE
                            : el.id === TYPES_DEPOSITS.WAVE)
                        .map((item: Record<string, any>) => (
                            <tr key={item.id}>
                                <td>
                                    <GxRadio
                                        onGx-change={() => formik.setFieldValue('deposit_type', item.id)}
                                        name="typeCertificate"
                                        checked={formik.values.deposit_type === item.id}>{item.title}</GxRadio>
                                </td>
                                <td>{item.count_price}</td>
                            </tr>
                        ))}
                    </tbody>
                  </table>
                </div>
                <div className={cn(styles['table'], styles['table--deposit'])}>
                  {formik.values.deposit_type !== TYPES_DEPOSITS.MONEY &&
                  <>
                    { isNotMoneyDeposit && list
                      .filter((item:Record<string,any>)=> item.expiry_at === null ? true : dayjs(item.expiry_at).isSameOrAfter(dayjs())).length === 0  ?
                      <div
                        className={styles['info']}>{TITLE_DEPOSIT_NUll[formik.values.deposit_type]} депозиты
                        отсутствуют...</div> :
                      <>
                        <table>
                          <thead>
                          <tr>
                            <th>Название</th>
                            <th>Действителен до</th>
                            <th>Длительность</th>
                          </tr>
                          </thead>
                          <tbody>
                          {
                            isNotMoneyDeposit && list
                              .filter((item:Record<string,any>)=> item.expiry_at === null ? true : dayjs(item.expiry_at).isSameOrAfter(dayjs()))
                              .map((item: Record<string, any>) => (
                              <tr key={item.id} className={classNames({[styles['table--not-in-interval']]: item.is_in_interval === false})}>
                                <td>
                                  <GxRadio
                                    name='deposit'
                                    onGx-change={() => formik.setFieldValue('deposit_id', item.id)}
                                    checked={item.id === formik.values.deposit_id}
                                  >
                                    {item.title}
                                  </GxRadio>
                                </td>
                                <td>{!item.expiry_at ? '-' : dayjs(item.expiry_at).format('YYYY.MM.DD')}</td>
                                <td>{getValueDepositField(item)}</td>
                              </tr>
                            ))
                          }
                          </tbody>
                        </table>
                      </>
                    }
                  </>
                  }
                </div>
              </div>
            </div>
            }
            {activeItem === PAYMENT_TYPE.CERTIFICATE &&
            <div className={styles['certificate']}>
              <div className={styles['subheader']}>
                <span className={styles['subheader--subtitle']}>Выбор сертификата</span>
              </div>
              <div className={cn(styles['table'], styles['table--certificate'])}>
                <table>
                  <thead>
                  <tr>
                    <th>Номер-серия</th>
                    <th>Действителен до</th>
                    <th>Цена</th>
                    <th>Труба, мин.</th>
                    <th>Волна, ар./сеты.</th>
                    <th>Статус</th>
                  </tr>
                  </thead>
                  <tbody>
                    {certificatesUser.results.map((item) => {
                      const { pipeMinutes, waveResource } = getCertificateResources(item);

                      return (
                        <tr
                          key={item.id}
                          className={item.is_in_interval ? '' : styles['table--certificate--danger']}
                        >
                          <td>
                            <GxRadio
                              onGx-change={() => formik.setFieldValue('certificate_id', item.id)}
                              name="typeCertificate"
                              checked={formik.values.certificate_id === item.id}
                            >
                              {item.number_series}
                            </GxRadio>
                          </td>
                          <td>{item.date_validity ? dayjs(item.date_validity).format('YYYY.MM.DD') : '-'}</td>
                          <td>{Number(item.price_paid).toLocaleString()}</td>
                          <td>{pipeMinutes}</td>
                          <td>{waveResource}</td>
                          <td>
                            <span
                              className={classNames(
                                styles['table--status-cert'],
                                styles[`table--status-cert_${NAME_TYPES_CERTIFICATE[TYPES_CERTIFICATE[item.status]].class}`]
                              )}
                            >
                              {NAME_TYPES_CERTIFICATE[TYPES_CERTIFICATE[item.status]].title}
                            </span>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
            }
            <div className={styles['footer']}>
              <div className={styles['footer--left-block']}>
                <div className={styles['pay-info']}>
                  <div className={styles['pay-info__item']}>
                    <p className={styles['pay-info__item_label']}>Сумма заказа:</p>
                    {isResourcePayment ? (
                      <p className={styles['pay-info__item_price']}>
                        {orderResourceTotal} {resourceUnit}
                      </p>
                    ) : (
                      <p className={styles['pay-info__item_price']}>
                        {priceInfo.base_price.toLocaleString()} ₽
                      </p>
                    )}
                  </div>
                  <div className={styles['pay-info__item']}>
                    <p className={styles['pay-info__item_label']}>Акция:</p>
                    {isResourcePayment ? (
                      <p className={styles['pay-info__item_price']}>
                        0 {resourceUnit}
                      </p>
                    ) : (
                      <p className={styles['pay-info__item_price']}>
                        {priceInfo.price_stock.toLocaleString()} ₽
                      </p>
                    )}
                  </div>
                  <div className={cn(styles['pay-info__item'], styles['pay-info__item_paid'])}>
                    <p className={styles['pay-info__item_label']}>Оплачено:</p>
                    {isResourcePayment ? (
                      <p className={styles['pay-info__item_price']}>
                        0 {resourceUnit}
                      </p>
                    ) : (
                      <p className={styles['pay-info__item_price']}>
                        {priceInfo.price_paid.toLocaleString()} ₽
                      </p>
                    )}
                  </div>
                  <div className={cn(styles['pay-info__item_container'])}>
                    <div className={cn(styles['pay-info__item'], styles['pay-info__item_total'])}>
                      <p className={styles['pay-info__item_label']}>
                        {isResourcePayment ? 'К оплате:' : 'К оплате (руб):'}
                      </p>
                      {isResourcePayment ? (
                        <p className={styles['pay-info__item_total']}>
                          <span className={styles['pay-info__item_price']}>
                            {orderResourceTotal} {resourceUnit}
                          </span>
                        </p>
                      ) : (
                        <p className={styles['pay-info__item_total']}>
                          <span className={styles['pay-info__item_price']}>
                            {priceInfo.price_total.toLocaleString()}
                          </span>{' '}
                          / {side === ORDERS.PIPE
                            ? `${tariff_rate.minutes} мин.`
                            : `${tariff_rate.count_people} сет(ов).`}
                        </p>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className={styles['footer--right-block']}>
                <GxButton className={styles['btn--gray']} onClick={onBack}>
                  Отмена
                </GxButton>
                {flagSpinner ? <GxSpinner style={{fontSize: '2rem'}}/> :
                  <GxButton
                    className={styles['btn--default']}
                    type='submit'
                    disabled={isDisabledPayment}
                  >
                    Оплатить
                  </GxButton>
                }
              </div>
            </div>
        </GxForm>
      </>
    );
};

export default PayOrder;